export default __webpack_public_path__ + "static/media/iluv.ad5509ab.jpg";